(function ($) {
  const initializeBlock = function ($block) {
    const $caseStudies = $block.find(".case-studies");
    if ($caseStudies.hasClass("slick-initialized")) {
      $caseStudies.slick("unslick");
    }

    $caseStudies.slick({
      infinite: true,
      arrows: false,
      dots: false,
      speed: 500,
      autoheight: true,
      autoplay: false,
      autoplaySpeed: 8000,
      slidesToShow: 1,
      cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
      fade: true,
      asNavFor: ".case-logos",
    });

    const $caseLogos = $block.find(".case-logos");
    if ($caseLogos.hasClass("slick-initialized")) {
      $caseLogos.slick("unslick");
    }

    $caseLogos.slick({
      asNavFor: ".case-studies",
      infinite: true,
      arrows: false,
      dots: false,
      speed: 500,
      centerMode: true,
      slidesToShow: 4,
      variableWidth: true,
      slideToScroll: 1,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    });
  };

  $(document).ready(function () {
    $(".block--case-study").each(function () {
      initializeBlock($(this));
    });
  });

  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=case-study",
      initializeBlock
    );
  }
})(jQuery);
